export default [
    {
        path: '/marketingRebates/billDetails',
        component: () => import('@/views/marketingRebates/billDetails'),
        name: 'PaymentDetails',
        meta: { title: '营销活动付款明细', icon: 'a-up', noCache: false },
        hidden: true
    },

]
